<div class="estado filter-container" *ngIf="showOptions" [formGroup]="filterForm">
  <!-- Banner de error cuando excede 31 días -->
  <div class="banner banner-error" *ngIf="showExceeds31DaysBanner">
    <mat-icon class="banner-icon">error</mat-icon>
    <span>El rango de fechas no puede superar los 31 días. Por favor, ajuste el rango.</span>
  </div>

  <div class="filter-container-group select-group">
    <!--Medio-->
    <mat-form-field appearance="outline" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.method' | translate }}</mat-label>
      <mat-select #medioPagoMatSelect multiple formControlName="paymentMethods">
        <mat-checkbox *ngIf="methodsValuesForSelect?.length > 1" [checked]="areAllPaymentMethodsSelected()"
          color="primary" (click)="$event.stopPropagation(); toggleAllPaymentMethods()" style="margin-left: 5px;">
          <div style="margin-bottom: -10px;"
            [ngStyle]="{ color: areAllPaymentMethodsSelected() ? 'var(--mat-option-selected-state-label-text-color)' : 'black' }">
            {{ areAllPaymentMethodsSelected() ? 'Anular selección' : 'Seleccionar todos' }}
          </div>
        </mat-checkbox>
        <mat-option *ngFor="let paymentMethod of methodsValuesForSelect" [value]="paymentMethod.value">
          {{ paymentMethod.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!--Estado-->
    <mat-form-field appearance="outline" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.state' | translate }}</mat-label>
      <mat-select #estadoMatSelect formControlName="paymentStates" multiple>
        <mat-checkbox *ngIf="statesValuesForSelect?.length > 1" [checked]="areAllPaymentStatesSelected()"
          color="primary" (click)="$event.stopPropagation(); toggleAllPaymentStates()" style="margin-left: 5px;">
          <div style="margin-bottom: -10px;"
            [ngStyle]="{ color: areAllPaymentStatesSelected() ? 'var(--mat-option-selected-state-label-text-color)' : 'black' }">
            {{ areAllPaymentStatesSelected() ? 'Anular selección' : 'Seleccionar todos' }}
          </div>
        </mat-checkbox>
        <mat-option *ngFor="let estado of statesValuesForSelect" [value]="estado.value">
          {{ translate(estado.display) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="filter-container-group">
    <!--Fecha desde-->
    <mat-form-field appearance="outline" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.date_from' | translate }}</mat-label>
      <div (click)="matDateToggleTo.datepicker.open()">
        <input style="cursor: pointer !important" matInput [matDatepicker]="picker" formControlName="dateFrom"
          [placeholder]="translate('pages.payment-link.labels.date')" readonly [min]="minDate" [max]="maxDate" />
      </div>
      <mat-datepicker-toggle #matDateToggleTo matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="filterForm.get('dateFrom')?.touched && filterForm.get('dateFrom')?.invalid">
        Campo requerido
      </mat-error>
    </mat-form-field>

    <!--Hora desde-->
    <div class="time-container">
      <mat-form-field appearance="outline" class="time-form-field">
        <mat-select formControlName="hourFrom" [disabled]="!filterForm?.get('dateFrom')?.value">
          <mat-option [value]="hour.value" *ngFor="let hour of hours">{{ hour.value }}</mat-option>
        </mat-select> </mat-form-field>:
      <mat-form-field appearance="outline" class="time-form-field">
        <mat-select formControlName="minutesFrom" [disabled]="!filterForm?.get('dateFrom')?.value">
          <mat-option [value]="minute.value" *ngFor="let minute of minutes">{{ minute.value }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span>Hs.</span>
    </div>
  </div>
  <div class="filter-container-group">
    <!--Fecha hasta-->
    <mat-form-field appearance="outline" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.date_to' | translate }}</mat-label>
      <div (click)="matDateToggleFrom.datepicker.open()">
        <input style="cursor: pointer !important" matInput [matDatepicker]="picker1" formControlName="dateTo"
          [min]="filterForm.get('dateFrom')?.value" [placeholder]="translate('pages.payment-link.labels.date')" readonly
          [max]="maxDateTo" [disabled]="!filterForm.get('dateFrom').value" />
      </div>
      <mat-datepicker-toggle #matDateToggleFrom matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      <mat-error *ngIf="filterForm.get('dateTo')?.touched && filterForm.get('dateTo')?.invalid">
        Campo requerido
      </mat-error>
    </mat-form-field>
    <!--Hora hasta-->
    <div class="time-container">
      <mat-form-field appearance="outline" class="time-form-field">
        <mat-select formControlName="hourTo" [disabled]="!filterForm?.get('dateTo')?.value">
          <mat-option [value]="hour.value" *ngFor="let hour of hours">{{ hour.value }}</mat-option>
        </mat-select> </mat-form-field>:
      <mat-form-field appearance="outline" class="time-form-field">
        <mat-select formControlName="minutesTo" [disabled]="!filterForm?.get('dateTo')?.value">
          <mat-option [value]="minute.value" *ngFor="let minute of minutes">{{ minute.value }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span>Hs.</span>
    </div>
  </div>

  <div class="filter-container-group select-group">
    <!--Sucursales-->
    <mat-form-field appearance="outline" *ngIf="showBranchesAndCashiers" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.branch' | translate }}</mat-label>
      <mat-select formControlName="branches" #branchMatSelect multiple>
        <mat-option>
          <ngx-mat-select-search [formControl]="searchBranch" placeholderLabel="Buscar sucursal"
            noEntriesFoundLabel="No se encontró sucursal"></ngx-mat-select-search>
        </mat-option>
        <mat-checkbox *ngIf="branchesValuesForSelect?.length > 1" [checked]="areAllBranchesSelected()" color="primary"
          (click)="$event.stopPropagation(); toggleAllBranches()" style="margin-left: 5px;">
          <div style="margin-bottom: -10px;"
            [ngStyle]="{ color: areAllBranchesSelected() ? 'var(--mat-option-selected-state-label-text-color)' : 'black' }">
            {{ areAllBranchesSelected() ? 'Anular selección' : 'Seleccionar todos' }}
          </div>
        </mat-checkbox>
        <mat-option *ngFor="let branchOffice of branchesValuesForSelect" [value]="branchOffice.value">
          {{ branchOffice.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!--Cajas-->
    <mat-form-field appearance="outline" *ngIf="showBranchesAndCashiers" class="filter-container-form-field">
      <mat-label>{{ 'pages.movements_list.cashier' | translate }}</mat-label>
      <mat-select formControlName="cashiers" #cashierMatSelect multiple>
        <mat-option *ngIf="cashierFilter?.length">
          <ngx-mat-select-search [formControl]="searchCashier" placeholderLabel="Buscar caja"
            noEntriesFoundLabel="No se encontró una caja"></ngx-mat-select-search>
        </mat-option>
        <mat-checkbox *ngIf="cashiersValuesForSelect?.length > 1" [checked]="areAllCashiersSelected()" color="primary"
          (click)="$event.stopPropagation(); toggleAllCashiers()" style="margin-left: 5px;">
          <div style="margin-bottom: -10px;"
            [ngStyle]="{ color: areAllCashiersSelected() ? 'var(--mat-option-selected-state-label-text-color)' : 'black' }">
            {{ areAllCashiersSelected() ? 'Anular selección' : 'Seleccionar todos' }}
          </div>
        </mat-checkbox>
        <mat-option *ngFor="let cashier of cashiersValuesForSelect" [value]="cashier.value">
          {{ cashier.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div style="width: 100%">
  <div class="buttons-filters" *ngIf="showOptions">
    <button mat-raised-button (click)="emitFilterButtonPressed()" [disabled]="isFilterButtonDisabled()"
      class="buttonFilter" color="primary">
      {{ 'pages.movements_list.buttons.filter' | translate }}
    </button>
    <button mat-raised-button appThrottledDirective appThrottled="click" appThrottledDuration="10000"
      (appThrottledEvent)="emitCleanFiltersValues()" color="primary" [disabled]="stateButtonClean()"
      class="clean-filters-button clean-filters">
      {{ 'pages.movements_list.buttons.clean_filters' | translate }}
    </button>
    <button mat-raised-button class="filter-button d-inline-flex" (click)="emitDownloadExcel()" color="primary"
      [disabled]="disableExport || filterForm.errors?.dateRangeError || filterForm.errors?.dateRangeExceeds31Days">
      <span *ngIf="!isLoadingExcel"> Exportar Excel </span>
      <div class="excel-spinner-container" *ngIf="isLoadingExcel">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
    </button>
  </div>
</div>